<template>
    <div>
        <div v-if="errorMessage" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ errorMessage }}</div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.data) }">
            <label for="_data" class="control-label">Plik</label>
            <vue-upload
                    id="_data"
                    class="btn btn-upload"
                    name="data"
                    ref="upload"
                    :headers="headers"
                    :data="item"
                    :post-action="fullPostAction"
                    @input-file="onchangeState">{{fileName}}<div class="btn btn-default"><span>Wybierz plik</span><svg-icon name="plus"/></div>
            </vue-upload>
            <span v-if="errors && errors.data" class="help-block" id="_data_helpBlock">{{ errors.data }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
            <label for="_name" class="control-label">Opis</label>
            <input v-model="item.name" type="text" placeholder="" id="_name" class="form-control"/>
            <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.type) }">
            <label for="_type" class="control-label">Typ</label>
            <dropdown-search
                    id="login_company"
                    :elements="fileTypes"
                    emptyValue="Wybierz typ pliku"
                    v-model="item.type"
                    valueField="@id"
                    nameField="name"/>
            <span v-if="errors && errors.type" class="help-block" id="_ty[e_helpBlock">{{ errors.type }}</span>
        </div>

    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import security from './../../utils/security'
  import http from './../../utils/http'
  import AuthorizationError from './../../error/AuthorizationError'
  import SubmissionError from './../../error/SubmissionError'
  import { API_HOST, API_PATH } from './../../config/_entrypoint'

  export default {
    props: {
      postAction: {
        type: String,
        require: true
      }
    },
    data: function () {
      return {
        item: {},
        errors: {},
        errorMessage: null,
        fileName: 'Wybierz plik'
      }
    },
    computed: {
      fullPostAction () {
        return API_HOST + API_PATH + this.postAction
      },
      headers () {
        return {
          authorization: 'Bearer ' + security.getToken()
        }
      },
      ...mapGetters({
        fileTypes: 'config/config/fileTypes',
      })
    },
    methods: {
      checkRequiredFile: function () {
        const errors = {}
        if (this.item.type == undefined || this.item.type == '') {
          errors.type = 'To pole nie może by puste'

        }
        if (this.item.name == undefined || this.item.name == '') {
          errors.name = 'To pole nie może by puste'
        }
        if (this.$refs.upload.files.length == 0) {
          errors.data = 'To pole nie może by puste'
        }
        return errors
      },
      onchangeState: function (newFile, oldFile) {
        // handle upload success
        if (newFile && oldFile && newFile.success) {
          this.$emit('loading', false)
          this.$emit('success', newFile.response)
        }
        // handle upload error
        if (newFile && oldFile && newFile.error && !oldFile.error) {
          this.$emit('loading', false)
          if (newFile.response.code === 401) {
            security.handleAuthorizationError(new AuthorizationError(newFile.response.message))
          } else {
            try {
              const json = JSON.parse(newFile.response)
              this.$emit('error', json)
              const error = http.buildError(json)
              if (error instanceof SubmissionError) {
                this.errors = error.errors
              } else {
                this.error = error.error
              }
            } catch (ex) {
              console.error(ex)
            }
          }
        }
        // new file was selected
        if (newFile && !oldFile) {
          this.fileName = newFile.file.name
        }
      },
      sendForm: function () {
        const errors = this.checkRequiredFile()
        if (errors.type !== undefined || errors.name != undefined || errors.data != undefined) {
          this.errors = errors
        } else {
          this.$emit('loading', true)
          this.errors = {}
          this.$refs.upload.active = false
          for (let index = 0; index < this.$refs.upload.files.length; index++) {
            this.$refs.upload.files[index].data = this.item
            this.$refs.upload.files[index].error = ''
            this.$refs.upload.files[index].success = false
          }
          this.$refs.upload.active = true
        }
      },
      resetForm: function () {
        this.errors = {}
        this.$refs.upload.files = []
        this.errorMessage = null
        this.fileName = ''
        this.item ={}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UploadFile.vue?4871eebf